import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Tooltip,
  Whisper,
  Stack,
  IconButton,
  InputGroup,
  Form,
  Message,
  Table,
  SelectPicker,
  toaster
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { ReviewPass } from '@rsuite/icons';
import { Popconfirm } from 'antd';

interface RowDataColor {
  id: string; // or number, depending on your data
  attributes: {
    ColorCode: string;
    ColorName: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const ColorMaster = () => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  ////////////////  Function For 5 Start /////////////////

  const [color, setColor] = useState({
    ColorCode: '',
    ColorName: '',
    dis: 'Continue'
  });
  // Fetch Data from API Start
  const [colordata, setColordata] = useState<RowDataColor[]>([]);
  const [colormeta, setColormeta] = useState<MetaData>();
  const [editedRowIdsColor, setEditedRowIdsColor] = useState<string[]>([]);
  const [editedRowIdColor, setEditedRowIdColor] = useState<string>('');
  const [editedDataColor, setEditedDataColor] = useState<
    Record<string, Partial<RowDataColor['attributes']>>
  >({});
  const [selectedBuyercolor, setSelectedBuyercolor] = useState('Continue');
  const [disColor, setDisColor] = useState([]);
  const handleBuyerChangecolor = value => {
    setSelectedBuyercolor(value);
  };
  const [isLoading5, setIsLoading5] = React.useState(false);

  useEffect(() => {
    fetchData5();
  }, [selectedBuyercolor]);
  const fetchData5 = async () => {
    if (isLoading5) {
      return;
    }
    setIsLoading5(true);
    let disFilter = '';
    if (selectedBuyercolor.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyercolor}`;
    }
    if (selectedBuyercolor == 'All') {
      disFilter = '';
    }
    const pageResponse = await fetch(
      `${globalIP}/api/mstcolors?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const pageJson = await pageResponse.json();
    const allData = [];
    for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstcolors?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${globalIP}/api/mstcolors?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();

    const response2 = await fetch(`${globalIP}/api/mstcolors`);
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstcolors?populate=*&pagination[page]=${page}`
      );
      const pageJson2 = await pageResponse.json();
      allData2.push(...pageJson2.data);
    }
    // setDisColor(allData2)
    setColormeta(jsonmeta.meta);
    setColordata(allData);
    setIsLoading5(false);
  };
  const processInputRef = useRef(null);
  const handleEditRowColor = rowData => {
    setColor({ ...rowData.attributes });
    setEditedRowIdColor(rowData.id);
    setEditedRowIdsColor(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataColor(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };

  const resetColor = () => {
    setColor({
      ColorCode: '',
      ColorName: '',
      dis: 'Continue'
    });
  };
  const handleCancelColor = rowData => {
    resetColor();
    setEditedRowIdColor('');
    setEditedRowIdsColor('');
  };
  const url5 = `${globalIP}/api/mstcolors`;
  const submit5 = async e => {
    const trimmedColorName = color.ColorName?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/

    if (trimmedColorName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.color}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (specialCharPattern.test(trimmedColorName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.color} {trimmedColorName} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const { data: colorN } = await axios.get(
          `${globalIP}/api/mstcolors?filters[ColorName][$eqi]=${trimmedColorName}`
        );
        const { data: colorNcode } = await axios.get(`${globalIP}/api/mstcolors?populate=*`);
        const nextCode = colorNcode.meta.pagination.total + 1;
        // const existingColor = disColor.find(
        //   item => item.attributes.ColorName.toLowerCase() === trimmedColorName.toLowerCase()
        // );

        if (colorN.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              {label[0]?.attributes.color} {trimmedColorName} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          e.preventDefault();
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              ...color,
              ColorName: trimmedColorName,
              ColorCode: `CLR-${nextCode.toString().padStart(3, '0')}`
            })
          );

          const response = await fetch(url5, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            await fetchData5();
            console.log(color);

            toaster.push(
              <Message showIcon type="success">
                Data Saved Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error('Error occurred while saving data', error);
      }

      setColor({
        ColorCode: '',
        ColorName: '',
        dis: 'Continue'
      });
    }
  };

  //  Fetch Data from API End
  const handleInputChange5 = (inputName, value, index) => {
    setColor({ ...color, [inputName]: value });
  };
  const handleColC = async (catalogId, ColorName) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...colordata,
        dis: 'Continue'
      })
    );
    fetch(`${globalIP}/api/mstcolors/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData5();

        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleColD = async (catalogId, ColorName) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...colordata,
        dis: 'Discontinue'
      })
    );
    fetch(`${globalIP}/api/mstcolors/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData5();

        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleUpdateColor = async () => {
    try {
      if (!color) {
        console.error('Row data not found.');
        return;
      }

      const { ColorName } = color || {};

      const invalidCharsRegex = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

      if (ColorName === '') {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.color}..
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (invalidCharsRegex.test(ColorName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.color} {ColorName} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      if (ColorName.startsWith(' ') || ColorName.endsWith(' ')) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.color} {ColorName} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      const { data: updatecolorN } = await axios.get(
        `${globalIP}/api/mstcolors?filters[ColorName][$eqi]=${ColorName}&filters[id][$ne]=${editedRowIdColor}`
      );

      if (updatecolorN.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.color} {ColorName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      const response = await fetch(`${globalIP}/api/mstcolors/${editedRowIdColor}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: color })
      });

      if (response.ok) {
        fetchData5();
        resetColor();
        setEditedRowIdColor('');
        setEditedDataColor(prevData => ({
          ...prevData,
          [editedRowIdColor]: { ...color }
        }));

        // Keep the row ID in edited state
        setEditedRowIdsColor(prevRowIds => [...new Set([...prevRowIds, editedRowIdColor])]);
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleSaveRowColor = async (rowId: string) => {
    try {
      const rowData = colordata.find(row => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }

      const updatedColorName = editedDataColor[rowId]?.ColorName?.trim();
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/
      const { data: updatecolorN } = await axios.get(
        `${globalIP}/api/mstcolors?filters[ColorName][$eqi]=${updatedColorName}&filters[id][$ne]=${rowId}`
      );
      if (!updatedColorName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.color}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (specialCharPattern.test(updatedColorName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.color} {updatedColorName} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (updatedColorName.startsWith(' ') || updatedColorName.endsWith(' ')) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.color} cannot start or end with a space.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // const existingColor = colordata.find(
      //   item => item.attributes.ColorName.toLowerCase() === updatedColorName.toLowerCase()
      // );

      if (updatecolorN.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.color} {updatedColorName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // const updatedRowData = {
      //   ...rowData,
      //   attributes: {
      //     ...rowData.attributes,
      //     ...editedDataColor[rowId],
      //     ColorName: updatedColorName
      //   }
      // };

      const response = await fetch(`${globalIP}/api/mstcolors/${editedRowIdColor}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: color })
      });

      if (response.ok) {
        fetchData5();
        resetColor();
        setEditedRowIdColor('');
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeColor = (rowId, fieldName, value) => {
    setEditedDataColor(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...colordata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  ////////////////  Function For 5 End /////////////////
  ////////////////  Searching For 5 Start /////////////////
  const [searchQuery5, setSearchQuery5] = useState('');
  const [filterStatus5, setFilteredStatus5] = useState('Continue');
  const handleSearch5 = value => {
    setSearchQuery5(value);
  };
  const [colorFilterData, setColorFilterData] = useState([]);

  useEffect(() => {
    const colorFilterData = colordata
      .slice()
      .reverse()
      .filter(item => {
        const ColorName = item.attributes.ColorName ? item.attributes.ColorName.toLowerCase() : '';
        return ColorName.includes(searchQuery5.toLowerCase());
      });
    setColorFilterData(colorFilterData);
  }, [colordata, filterStatus5, searchQuery5]);
  ////////////////  Searching For 5 End /////////////////

  return (
    <>
      <Form.ControlLabel>
        <b>{label[0]?.attributes.color}</b>
      </Form.ControlLabel>
      <Stack justifyContent="space-between" style={{ marginBottom: '10px' }} className="mstr-panel">
        <Stack spacing={160} className="mstr-panel1">
          <Input
            id="ColorName"
            name="ColorName"
            style={{ width: '180%' }}
            autoComplete="off"
            ref={processInputRef}
            value={color && color.ColorName ? color.ColorName : ''}
            onChange={value => handleInputChange5('ColorName', value, 0)}
            onPressEnter={submit5}
            className="mstr-btn"
          />
          {editedRowIdColor ? (
            <Button
              appearance="primary"
              color="cyan"
              onClick={handleUpdateColor}
              style={{ marginLeft: '10px' }}
            >
              {' '}
              Update
            </Button>
          ) : (
            <Button
              appearance="primary"
              color="cyan"
              onClick={submit5}
              style={{ marginLeft: '10px' }}
            >
              {' '}
              Add
            </Button>
          )}
        </Stack>
        <Stack className="mstr-search" spacing={5}>
          <SelectPicker
            data={data}
            placeholder="Status"
            labelKey="label"
            value={selectedBuyercolor}
            onChange={handleBuyerChangecolor}
            searchable={false}
            valueKey="value"
            size="md"
            appearance="default"
            style={{ width: 130 }}
            cleanable={false}
          />
          <InputGroup inside>
            <Input placeholder="Search" type="text" value={searchQuery5} onChange={handleSearch5} />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
      <Table
        rowHeight={60}
        data={colorFilterData}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading5}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
        </Table.Column>

        <Table.Column width={130} flexGrow={1}>
          <Table.HeaderCell>
            <b>{label[0]?.attributes.color}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                // editedRowIdsColor.includes(rowData.id) ? (
                //   <Input
                //     value={editedDataColor[rowData.id]?.ColorName || ''}
                //     onChange={value => handleInputChangeColor(rowData.id, 'ColorName', value)}
                //   />
                // ) : (
                rowData.attributes.ColorName
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsColor.includes(rowData.id) ? (
                <div>
                  {/* <IconButton
                    size="sm"
                    icon={<CheckIcon />}
                    active
                    onClick={() => handleSaveRowColor(rowData.id)}
                    style={{ marginRight: '10px' }}
                  /> */}
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    style={{ marginRight: '10px' }}
                    onClick={() => handleEditRowColor(rowData)}
                  />
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={handleCancelColor}
                  // onClick={() =>
                  //   setEditedRowIdsColor(prevRowIds => prevRowIds.filter(id => id !== rowData.id))
                  // }
                  />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowColor(rowData)}
                  />
                  {rowData.attributes.dis === 'Discontinue' ? (
                    <Popconfirm
                      title="Continue Color"
                      description="Are you sure you want to continue this Color?"
                      onConfirm={() => handleColC(rowData.id, rowData.attributes.ColorName)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Continue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<CheckRoundIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleColC(rowData.id, rowData.attributes.ColorName)}
                        />
                      </Whisper>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Discontinue Color"
                      description="Are you sure you want to discontinue this Color?"
                      onConfirm={() => handleColD(rowData.id, rowData.attributes.ColorName)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Discontinue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<ReviewPass />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleColD(rowData.id, rowData.attributes.ColorName)}
                        />
                      </Whisper>
                    </Popconfirm>
                  )}
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <div>
        <p>
          <small>Total row:{colorFilterData.length}</small>
        </p>
      </div>
    </>
  );
};

export default ColorMaster;
